// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Accordion from '../smart-accordion';
import AccordionState from '../smart-accordion/state/accordion';
import {FormattedMessage} from 'react-intl';
import NavigationList from '../navigation-list';

const ReportLinks = props => {

    const reportLinksTitle = (
        <div className='report-links-title'>
            <FormattedMessage id='REPORTS'/>
        </div>
    );

    const reportLinksBody = (
        <div className='report-links-body'>
            <NavigationList
                parentRoute={props.parentRoute}
                routes={props.routes.childRoutes}
            />
        </div>
    );

    return (
        <Accordion
            accordion={props.accordion}
            body={reportLinksBody}
            onAccordionToggle={props.onAccordionToggle}
            title={reportLinksTitle}
        />
    );

};

ReportLinks.displayName = 'ReportLinks';
ReportLinks.propTypes = {
    accordion: PropTypes.instanceOf(AccordionState).isRequired,
    onAccordionToggle: PropTypes.func.isRequired,
    parentRoute: PropTypes.string.isRequired,
    routes: PropTypes.object.isRequired
};

export default ReportLinks;



// WEBPACK FOOTER //
// ./src/shared/components/report-links/index.js